// Copyright (c) 2016 Deere & Company

import {updateClaimModalMode, updateCreateClaimModalVisibility} from './create-claim-modal-visibility';
import actions from '../../action-list';
import {createTrackClaim} from './validate-claim';
import {getUpdatedTrackClaim} from '../services/update-track-claim';
import {isActionResetFormValidation} from '../../shared/services/claim-shared-helper';

export const updateSelectedAction = selectedAction =>

    (dispatch, getState) => {

        const updatedClaim = getUpdatedTrackClaim(getState().claims.track.claim, selectedAction);

        const updateModalVisibility = () => {

            updateClaimModalMode('CREATE')(dispatch);
            updateCreateClaimModalVisibility(true)(dispatch);

        };

        const updateIsEditable = () => {

            dispatch({
                isEditable: true,
                type: actions.UPDATE_CLAIM_TRACK_IS_EDITABLE
            });

            dispatch({
                type: actions.REVISE_CLAIM_TRACK
            });

        };

        if (isActionResetFormValidation(selectedAction.id)) {

            dispatch({
                type: actions.RESET_CLAIM_TRACK_FORM_VALIDATION
            });

        }

        const selectedActionIdTypes = {
            CRT: updateModalVisibility,
            REVISE: updateIsEditable
        };

        const updateType = selectedActionIdTypes[selectedAction.id];

        return updateType ? updateType() : createTrackClaim(updatedClaim)(dispatch, getState);

    };



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/update-selected-action.js